var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0H11.3781C11.775 0 12.1562 0.159375 12.4375 0.440625L14.5594 2.5625C14.8406 2.84375 15 3.225 15 3.62188V10.5C15 11.3281 14.3281 12 13.5 12H7.5C6.67188 12 6 11.3281 6 10.5V1.5C6 0.671875 6.67188 0 7.5 0ZM2.5 4H5V6H3V14H9V13H11V14.5C11 15.3281 10.3281 16 9.5 16H2.5C1.67188 16 1 15.3281 1 14.5V5.5C1 4.67188 1.67188 4 2.5 4Z",
    fill: "#4F546D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDark);
export default __webpack_public_path__ + "static/media/copy-dark.6d20466efcd6958bfe65208b23adc720.svg";
export { ForwardRef as ReactComponent };